<script lang="ts">
  import { trapFocus } from '../actions/trapFocus';

  export let open: boolean = false;
  export let message: string = '';
  export let onConfirm: () => void = () => {};
  export let onCancel: () => void = () => {};
</script>

{#if open}
  <div id="confirm-overlay" class="open" on:click={onCancel} role="dialog" aria-label="Confirmation" aria-labelledby="confirm-msg" tabindex="-1">
    <div class="confirm-box" use:trapFocus on:click|stopPropagation>
      <p id="confirm-msg">{message}</p>
      <div class="confirm-actions">
        <button id="confirm-cancel" on:click={onCancel}>Cancel</button>
        <button id="confirm-ok" on:click={onConfirm}>Continue</button>
      </div>
    </div>
  </div>
{/if}
